<template>
	<div id="newQianniuExam">
		<div class="el-tabs el-tabs--left">
			<div class="el-tabs__header is-left">
				<div class="el-tabs__nav-wrap is-left">
					<div class="el-tabs__nav-scroll">
						<div class="el-tabs__nav is-left">
							<div class="el-tabs__active-bar is-left" style="height: 50px; transform: translateY(0px);"></div>
							<div id="tab-first" class="el-tabs__item js-tab is-left is-active">
								<div class="tab-slot">
									<p class="title">1、搜狗输入法的截屏功能</p>
								</div>
							</div>
							<div id="tab-second" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">2、搜狗输入法的快捷短语</p>
								</div>
							</div>
							<!-- <div id="tab-third" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">3、Excel内容布局</p>
								</div>
							</div>
							<div id="tab-four" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">4、保存文件</p>
								</div>
							</div>
							<div id="tab-five" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">5、发送文件</p>
								</div>
							</div>
							<div id="tab-six" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">6、Word基础功能</p>
								</div>
							</div>
							<div id="tab-seven" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">7、下载安装WPS</p>
								</div>
							</div> -->
							<!-- <div id="tab-eight" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">8、转接功能</p>
								</div>
							</div>
							<div id="tab-nine" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">9、商品插件学习</p>
								</div>
							</div>
							<div id="tab-ten" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">10、订单插件学习</p>
								</div>
							</div>
							<div id="tab-eleven" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">11、新建任务</p>
								</div>
							</div>
							<div id="tab-twelve" class="el-tabs__item js-tab is-left">
								<div class="tab-slot">
									<p class="title">12、退出千牛</p>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
			<div class="el-tabs__content">
				<div id="tab-first-content" class="el-tab-pane">
					<div id="stoptip-first" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-first" class="content">
						<div class="con-left">
							<!--双击图标-->
					<div v-show="isShowqh1_1" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-1.png" />
							<img class="qhtb1-1" src="../../../static/workoff/excelimg/sougou/qhtb1-1.png" @mousemove="showLoginqh1_1" />
						</div>
						<div v-show="isShowqh1_2" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-2.png" />
							<img class="qhtb1-2" src="../../../static/workoff/excelimg/sougou/qhtb1-2.png" @click="showLoginqh1_2" />
						
						</div>
						<div v-show="isShowqh1_3" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-3.png" />
							<img class="qhtb1-3" src="../../../static/workoff/excelimg/sougou/qhtb1-3.png" @mousemove="showLoginqh1_3" />
						
						</div>
						<div v-show="isShowqh1_4" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-4.png" />
							<img class="qhtb1-4" src="../../../static/workoff/excelimg/sougou/qhtb1-4.png" @click="showLoginqh1_4" />
						
						</div>
						<div v-show="isShowqh1_5" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-5.png" />
							<!-- <img class="qhtb1-4" src="../../../static/workoff/excelimg/sougou/qhtb1-4.png" @click="showLoginqh1_4" /> -->
							
						</div>
                        <!-- 设置截屏 -->
                        <div v-show="isShowjp1_1" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/qh1-5.png" />
							<img class="jptb1-1" src="../../../static/workoff/excelimg/sougou/jptb1-1.png" @mousemove="showLoginjp1_1" />
						</div>
                        <div v-show="isShowjp1_2" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/jp1-1.png" />
							<img class="jptb1-2" src="../../../static/workoff/excelimg/sougou/jptb1-2.png" @click="showLoginjp1_2" />
						</div>
                        <div v-show="isShowjp1_3" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/jp1-2.png" />
							<img class="jptb1-3" src="../../../static/workoff/excelimg/sougou/jptb1-3.png" @mousemove="showLoginjp1_3" />
						</div>
                        <div v-show="isShowjp1_4" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/jp1-3.png" />
							<img class="jptb1-3" src="../../../static/workoff/excelimg/sougou/jptb1-3.png" @contextmenu.prevent.stop="showLoginjp1_4($event)" />
						</div>
                        <div v-show="isShowjp1_5" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/jp1-4.png" />
							<img class="jptb1-4" src="../../../static/workoff/excelimg/sougou/jptb1-4.png" @click="showLoginjp1_5" />
						</div>
                        <div v-show="isShowjp1_6" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/jp1-5.png" />
							<!-- <img class="jptb1-4" src="../../../static/workoff/excelimg/sougou/jptb1-4.png" @mousemove="showLoginjp1_5" /> -->
						</div>
                        <!-- 设置截屏快捷键 -->
                        <div v-show="isShowkj1_1" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-1.png" />
							<img class="kjtb1-1" src="../../../static/workoff/excelimg/sougou/kjtb1-1.png" @mousemove="showLoginkj1_1" />
						</div>
                        <div v-show="isShowkj1_2" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-2.png" />
							<img class="kjtb1-2" src="../../../static/workoff/excelimg/sougou/kjtb1-1.png" @click="showLoginkj1_2" />
						</div>
                        <div v-show="isShowkj1_3" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-1.png" />
							<img class="kjtb1-3" src="../../../static/workoff/excelimg/sougou/kj1-3.png" />
							<img class="kjtb1-4" src="../../../static/workoff/excelimg/sougou/kjtb1-2.png" @click="showLoginkj1_3" />
						</div>
                        <div v-show="isShowkj1_4" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-4.png" />	
							<img class="kjtb1-5" src="../../../static/workoff/excelimg/sougou/kjtb1-3.png" @mousemove="showLoginkj1_4" />
						</div>
                        <div v-show="isShowkj1_5" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-5.png" />	
							<img class="kjtb1-6" src="../../../static/workoff/excelimg/sougou/kjtb1-4.png" @click="showLoginkj1_5" />
						</div>
                        <div v-show="isShowkj1_6" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-6.png" />	
							<img class="kjtb1-6" src="../../../static/workoff/excelimg/sougou/kjtb1-4.png" />
							<div class="kjtb1-6-1_box"><img class="kjtb1-6-1" src="../../../static/workoff/excelimg/sougou/kj1-7.png" />
							<img class="kjtb1-8" src="../../../static/workoff/excelimg/sougou/kjtb1-6.png" @mousemove="showLoginkj1_6"/>
							</div>
							
						</div>
                        <!-- <div v-show="isShowkj1_7" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-6.png"/>
							<img class="kjtb1-7" src="../../../static/workoff/excelimg/sougou/kjtb1-5.png"/>
							<img class="kjtb1-8" src="../../../static/workoff/excelimg/sougou/kjtb1-6.png" @mousemove="showLoginkj1_6"/>
						</div> -->
                        <div v-show="isShowkj1_8" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-8.png"/>	
							
							<img class="kjtb1-9" src="../../../static/workoff/excelimg/sougou/kjtb1-7.png" @click="showLoginkj1_7"/>
						</div>
						<!-- 快捷键 -->
                        <div v-show="isShowkj1_9" class="qnbox">
							<!-- <img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-9.png" @mousewheel.prevent="showLoginkj1_8"/>	 -->
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-9.png" />
							<div class="kjtb1-9-1">
								<img class="kjtb1-10" src="../../../static/workoff/excelimg/sougou/kjtb1-8-1.png" />
								<img class="kjtb1-11" src="../../../static/workoff/excelimg/sougou/kjtb1-9.png" @mousemove="showLoginkj1_9"/>	
							</div>	
						</div>
                        <!-- <div v-show="isShowkj1_10" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-9.png"/>	
							<img class="kjtb1-10" src="../../../static/workoff/excelimg/sougou/kjtb1-8.png" />
							<img class="kjtb1-11" src="../../../static/workoff/excelimg/sougou/kjtb1-9.png" @mousemove="showLoginkj1_9"/>
						</div> -->
                        <div v-show="isShowkj1_11" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-10.png"/>	
							<img class="kjtb1-12" src="../../../static/workoff/excelimg/sougou/kjtb1-10.png" @click="showLoginkj1_10"/>
							
						</div>
                        <div v-show="isShowkj1_12" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/kj1-11.png"/>	
						
							
						</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<!--双击图标-->
							<p v-if="isShowqh1_1 || isShowqh1_2 || isShowqh1_3 || isShowqh1_4 || isShowqh1_5">将<span style="color: red;font-weight:bold;">左侧练习场</span>中，<span style="color: red;font-weight:bold;">右下角</span>的输入法<span style="color: red;font-weight:bold;">切换</span>为<span style="color: red;font-weight:bold;">搜狗输入法</span></p>
							<p v-if="isShowjp1_1 || isShowjp1_2 || isShowjp1_3 || isShowjp1_4 || isShowjp1_5 || isShowjp1_6">打开搜狗输入法的<span style="color: red;font-weight:bold;">智能输入助手,</span>将<span style="color: red;font-weight:bold;">截屏</span>功能快捷方式设置到<span style="color: red;font-weight:bold;">桌面</span>上</p>
							<p v-if="isShowkj1_1 || isShowkj1_2 || isShowkj1_3 || isShowkj1_4 || isShowkj1_5 || isShowkj1_6 || isShowkj1_8 || isShowkj1_9 || isShowkj1_10 || isShowkj1_11|| isShowkj1_12">在搜狗输入法的<span style="color: red;font-weight:bold;">菜单</span>中，将<span style="color: red;font-weight:bold;">截屏</span>的<span style="color: red;font-weight:bold;">快捷键</span>设置为Ctrl+Alt+Q</p>
						</div>
					</div>
					<div id="studytip-first" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>实操通关，进入下一关吧</p>
							<p>
								<a class="startstudy" @click="studyNext('#tab-second', 2, 'second')">GO，下一关</a>
							</p>
						</div>
					</div>
				</div>
                <div id="tab-second-content" class="el-tab-pane" :class="{mynone: tabCurrent !== 'second'}">
					<div id="stoptip-second" class="stoptip">
						<div class="tip">
							<span class="el-icon-success"></span>
							<p>
								<a class="startstudy" @click="startStudy">开始实操练习</a>
							</p>
						</div>
					</div>
					<div id="content-second" class="content">
						<div class="con-left">
							<!--挂起-->
							<div v-show="isShowdy1_1" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-1.png" />
							<img class="dytb1-1" src="../../../static/workoff/excelimg/sougou/dytb1-1.png" @mousemove="showLogindy1_1" />
					</div>
					<div v-show="isShowdy1_2" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-2.png" />
							<img class="dytb1-2" src="../../../static/workoff/excelimg/sougou/dytb1-2.png" @click="showLogindy1_2" />
					</div>
					<div v-show="isShowdy1_3" class="qnbox">
							<!-- <img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-3.png" @mousewheel.prevent="showLogindy1_3"/> -->
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-3.png"/>
							<div class="qnbg1-3-1box">
								<img class="dytb1-3" src="../../../static/workoff/excelimg/sougou/dytb1-4.png"  />
								<img class="dytb1-4" src="../../../static/workoff/excelimg/sougou/dytb1-5.png" @mousemove='showLogindy1_3' />
							</div>
							<!-- <img class="dytb1-2" src="../../../static/workoff/excelimg/sougou/dytb1-2.png"  /> -->
					</div>
					<div v-show="isShowdy1_4" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-4.png" />
							<img class="dytb1-5" src="../../../static/workoff/excelimg/sougou/dytb1-6.png"  @click="showLogindy1_4"/>
					</div>
					<div v-show="isShowdy1_5" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-5.png" />
							<img class="dytb1-6" src="../../../static/workoff/excelimg/sougou/dytb1-7.png"  @mousemove="showLogindy1_5"/>
					</div>
					<div v-show="isShowdy1_6" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-6.png" />
							<img class="dytb1-7" src="../../../static/workoff/excelimg/sougou/dytb1-8.png"  @click="showLogindy1_6"/>
					</div>
					<div v-show="isShowdy1_7" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-7.png" />
							<div class="isShowdy1_7_input"><el-input v-model="isShowdy1_7_input"></el-input></div>
							<div class="isShowdy1_7_textarea"><el-input type="textarea" :rows="2"  v-model="isShowdy1_7_textarea" resize="none"></el-input></div>
							<!-- <div class="isShowdy1_7_select"> 
								<el-select v-model="isShowdy1_7_select" >
									<el-option v-for="item in isShowdy1_7_selectopint" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div> -->
							<img class="dytb1-8" src="../../../static/workoff/excelimg/sougou/dytb1-9.png"  @click="showLogindy1_7"/>			
					</div>
					<div v-show="isShowdy1_8" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-9.png" />
							<div class="isShowdy1_7_input"><el-input v-model="isShowdy1_7_input"></el-input></div>
							<div class="isShowdy1_7_textarea"><el-input type="textarea" :rows="2"  v-model="isShowdy1_7_textarea" resize="none"></el-input></div>
							<div class="isShowdy1_7_select"> 
								<el-select v-model="isShowdy1_7_select" >
									<el-option v-for="item in isShowdy1_7_selectopint" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
							<img class="dytb1-9" src="../../../static/workoff/excelimg/sougou/dytb1-10.png"  @click="showLogindy1_8"/>			
					</div>
					<div v-show="isShowdy1_9" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy1-11.png" />
							<!-- <img class="dytb1-7" src="../../../static/workoff/excelimg/sougou/dytb1-8.png"  @click="showLogindy1_6"/> -->
					</div>
					<!-- 调用页面 -->
					<div v-show="isShowdy1_10" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy2-1.png" />
							<!-- <img class="dytb1-7" src="../../../static/workoff/excelimg/sougou/dytb1-8.png"  @click="showLogindy1_6"/> -->
					</div>
					<div v-show="isShowdy1_11" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy2-2.png" />
							<img class="dytb2-1" src="../../../static/workoff/excelimg/sougou/dytb2-1.png"  @mousemove="showLogindy1_10"/>
					</div>
					<div v-show="isShowdy1_12" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy2-3.png" />
							<img class="dytb2-1" src="../../../static/workoff/excelimg/sougou/dytb2-1.png"  @click="showLogindy1_11"/>
					</div>
					<div v-show="isShowdy1_13" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy2-4.png" />
							<img class="dytb2-2" src="../../../static/workoff/excelimg/sougou/dytb2-2.png" @click="showLogindy1_12"/>
					</div>
					<div v-show="isShowdy1_14" class="qnbox">
							<img class="qnbg" src="../../../static/workoff/excelimg/sougou/dy2-5.png" />
						
					</div>
						</div>
						<div class="con-right">
							<h3>
								<span class="line"></span>
								提示
							</h3>
							<p v-if="isShowdy1_1 || isShowdy1_2 || isShowdy1_3 || isShowdy1_4 || isShowdy1_5 || isShowdy1_6">按照以下要求添加短语:<br>
								缩写：<span style="color: red;font-weight:bold;">bb</span><br>
								内容：<span style="color: red;font-weight:bold;">报备：去上厕所，离开3分钟</span><br>
								点击<span style="color: red;font-weight:bold;">确定并继续添加</span>
							</p>

						    <p v-if="isShowdy1_7 ">按照以下要求添加短语：<br>缩写：<span style="color: red;font-weight:bold;">bb</span><br>内容：<span style="color: red;font-weight:bold;">报备：去上厕所，离开3分钟</span><br>点击<span style="color: red;font-weight:bold;">确定并继续添加</span></p>
						    <p v-if="isShowdy1_8 || isShowdy1_9">按照以下要求添加短语：<br>缩写：<span style="color: red;font-weight:bold;">bb</span><br>候选位置：<span style="color: red;font-weight:bold;">2</span><br>内容：<span style="color: red;font-weight:bold;">报备：去上厕所，离开5分钟</span><br>点击<span style="color: red;font-weight:bold;">确定</span></p>
						    <p v-if="isShowdy1_10 || isShowdy1_11 || isShowdy1_12 || isShowdy1_13 || isShowdy1_14">在聊天输入框中输入<span style="color: red;font-weight:bold;">bb</span>，调出快捷短语，选择离开<span style="color: red;font-weight:bold;">5分钟</span>的短语，并<span style="color: red;font-weight:bold;">发送</span></p>
						</div>
					</div>
					<div id="studytip-second" class="stoptip" v-if="OnInline=='false'">
						<div class="tip">
							<span class="el-icon-success"></span>
            					<p>你已完成搜狗输入法的功能学习</p>
	        					<!-- <a class="restart" @click="restartVideoLast"><i class="el-icon-refresh-left"></i>重看视频</a> -->
	        					<a class="startstudy" href="/tjkStudy/simulate/newqianniuexam" style="width: 160px;">去观看下载视频</a>
						</div>
					</div>
				</div>
				
            </div>
            <!-- 666666 -->
		</div>
	 </div>
</template>

<script>
export default {
  data() {
    return {
		OnInline:'false',//小助手跳转
    	tabCurrent: 'first',
    	//第1步
    	isShowQnIcon: true, //是否显示千牛图标
    	isShowQnIcon2: false, //显示点击千牛图标后图片
      isShowLoginImg: false, //是否显示登录图片
      name: '', //登录账号
     	password: '', //密码
     	showPassword: false, //显示账号密码
     	isShowRnd: false, //显示获取随机码
     	rnd: '', //随机密码
     	showRnd: false, //显示随机码
     	isShowLoginIndex: false, //显示登录后图片
     	isShowLoginIndexTwo: false, //显示接待中心


		//第1步
        isShowqh1_1:true,//显示切换输入法页面
        isShowqh1_2:false,//鼠标移入切换输入法
        isShowqh1_3:false,//鼠标点击切换输入法
        isShowqh1_4:false,//鼠标移入搜狗输入法
        isShowqh1_5:false,//鼠标点击搜狗输入法
        // 设置截屏
        isShowjp1_1:false,//延时两秒设置截屏页面显示
        isShowjp1_2:false,//鼠标移入输入法设置
        isShowjp1_3:false,//鼠标点击输入法设置
        isShowjp1_4:false,//鼠标移入截屏设置
        isShowjp1_5:false,//点击鼠标右键
        isShowjp1_6:false,//鼠标点击发送到桌面
        //设置截屏快捷键
        isShowkj1_1:false,//延时两秒显示设置截屏快捷键页面
        isShowkj1_2:false,//鼠标移入输入法图标
        isShowkj1_3:false,//鼠标点击输入法（菜单）图标
        isShowkj1_4:false,//鼠标点击更多设置
        isShowkj1_5:false,//鼠标移入按钮
        isShowkj1_6:false,//鼠标点击按钮,鼠标滚轮滑动
        // isShowkj1_7:false,//监听滚轮滚动
        isShowkj1_8:false,//鼠标移入系统功能快捷键设置
        isShowkj1_9:false,//鼠标点击系统功能快捷键设置
        isShowkj1_10:false,//监听滚轮滚动
        isShowkj1_11:false,//鼠标移入截屏
        isShowkj1_12:false,//鼠标点击截屏


     	
		//第2步
		// 搜狗输入法的快捷短语
		isShowdy1_1:true,//显示快捷短语的第一张图片
		isShowdy1_2:false,//鼠标移入高级
		isShowdy1_3:false,//鼠标点击高级
		isShowdy1_4:false,//鼠标移入自定义短语
		isShowdy1_5:false,//鼠标点击自定义短语
		isShowdy1_6:false,//鼠标移入添加新短语
		isShowdy1_7:false,//鼠标点击添加新短语
		isShowdy1_7_input:'',//缩写输入框
		isShowdy1_7_textarea:'',//内容输入框
		isShowdy1_7_select:1,//候选位置值
		isShowdy1_7_selectopint:[
			{value:1,
			label:1
			},
			{value:2,
			label:2
			},
			{value:3,
			label:3
			},
			{value:4,
			label:4
			},
			{value:5,
			label:5
			},
			{value:6,
			label:6
			},
			{value:7,
			label:7
			},
			{value:8,
			label:8
			},
			{value:9,
			label:9
			}
		],//候选位置下拉框值
		isShowdy1_8:false,//鼠标点击确定并添加
		isShowdy1_9:false,//鼠标点确定

		// 显示调用界面
		isShowdy1_10:false,//鼠标点击高级
		isb:0,//记录b按下次数
		isShowdy1_11:false,//键盘连续输入bb
		isShowdy1_12:false,//键盘移入2
		isShowdy1_13:false,//键盘点击2
		isShowdy1_14:false,//鼠标点击发送
     	
    }
  },
  mounted() {
  	$('#stoptip-'+this.tabCurrent).show();
  	this.initAll();
  	var step = this.$route.query.step;
  	if(step == 12){
        this.studyNext('#tab-twelve', step, 'twelve')
	}
	var _this=this
  document.onkeydown = function (event) {
    let key = window.event.keyCode;
	console.log(key,88877)
    if (key === 83 && event.ctrlKey) { 
	    event.returnValue = false // 阻止直接保存网页
		if(_this.isShowbc1_1==true){
			_this.showLoginbc1_1()
		}
		
     // 监听ctrl+S组合键      
       
    } 
    if (key === 67 && event.ctrlKey) { 
	
		if(_this.isShowfs1_4==true){
			_this.Loginfs1_4()
		}
		if(_this.isShownr1_7==true){
			_this.showLoginnr1_7()
		}
	    
	   
      // 监听ctrl+C组合键      
       
    } 
    if (key === 86 && event.ctrlKey) { 
		if(_this.isShowfs1_5==true){
			_this.Loginfs1_5()
		}
		if(_this.isShownr1_9==true){
			_this.listenTwo_3()
		}
	    
	   
      // 监听ctrl+V组合键      
       
    } 
    if (key === 13) { 
		if(_this.isShowqh1_4==true){
			_this.showLoginqh1_4()
		}
		if(_this.isShowpj1_3==true){
			_this.showLoginpj1_1()
		}
		if(_this.isShowzf1_4==true){
			_this.showLoginzf1_1()
		}
		if(_this.isShowzb1_4==true){
			_this.showLoginzb1_1()
		}
		if(_this.isShowfs1_6==true){
			_this.Loginfs1_6()
		}
		if(_this.isShowdy1_13==true){
			_this.showLogindy1_12_1()
		}
	
	    
	   
      // 监听回车     
       
    } 
    if (key === 65 && event.ctrlKey) { 
		if(_this.isShowwdzt1_1==true){
			event.returnValue = false // 阻止
			_this.Loginwdzt1_1()
		}
		
	
	    
	   
      // 监听ctrl+A     
       
    } 
    if (key === 66) { 
		_this.isb++
		console.log(_this.isb,888)
		if(_this.isShowdy1_10==true){
			if(_this.isb==2){
				_this.showLogindy1_9()
			}
		}else{
			_this.isb=0
		}
      // 监听连续按下两次b    
    }else{
		_this.isb=0
	}
	if(key === 50 || key===98){
		if(_this.isShowdy1_11==true){
			_this.showLogindy1_10_1()
		}
	}
   
  }
  },
  watch: {
  	kjdy: function() {
  		if(this.kjdy == '/结束') {
  			this.isShowKjdy06 = true
  		}
  	}
  },
  directives: {
    focus: {
      inserted: function(el, {value}) {
        if(value){
          el.focus();
        }
      }
    }
  },
    created(){
	  if(this.$route.query.OnInline){
		 this.OnInline=this.$route.query.OnInline  
	  }
  },
  methods: {
  	formatDate: function (value) {
	    let date = new Date(value);
	    let y = date.getFullYear();
	    let MM = date.getMonth() + 1;
	    MM = MM < 10 ? ('0' + MM) : MM;
	    let d = date.getDate();
	    d = d < 10 ? ('0' + d) : d;
	    let h = date.getHours();
	    h = h < 10 ? ('0' + h) : h;
	    let m = date.getMinutes();
	    m = m < 10 ? ('0' + m) : m;
	    let s = date.getSeconds();
	    s = s < 10 ? ('0' + s) : s;
	    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
	  },
	  //初始化第1步状态值
    initFirst() {
    	this.isShowqh1_1=true,//显示切换输入法页面
        this.isShowqh1_2=false,//鼠标移入切换输入法
        this.isShowqh1_3=false,//鼠标点击切换输入法
        this.isShowqh1_4=false,//鼠标移入搜狗输入法
        this.isShowqh1_5=false,//鼠标点击搜狗输入法
        // 设置截屏
        this.isShowjp1_1=false,//延时两秒设置截屏页面显示
        this.isShowjp1_2=false,//鼠标移入输入法设置
        this.isShowjp1_3=false,//鼠标点击输入法设置
        this.isShowjp1_4=false,//鼠标移入截屏设置
        this.isShowjp1_5=false,//点击鼠标右键
        this.isShowjp1_6=false,//鼠标点击发送到桌面
        //设置截屏快捷键
        this.isShowkj1_1=false,//延时两秒显示设置截屏快捷键页面
        this.isShowkj1_2=false,//鼠标移入输入法图标
        this.isShowkj1_3=false,//鼠标点击输入法（菜单）图标
        this.isShowkj1_4=false,//鼠标点击更多设置
        this.isShowkj1_5=false,//鼠标移入按钮
        this.isShowkj1_6=false,//鼠标点击按钮,鼠标滚轮滑动
        // isShowkj1_7:false,//监听滚轮滚动
        this.isShowkj1_8=false,//鼠标移入系统功能快捷键设置
        this.isShowkj1_9=false,//鼠标点击系统功能快捷键设置
        this.isShowkj1_10=false,//监听滚轮滚动
        this.isShowkj1_11=false,//鼠标移入截屏
        this.isShowkj1_12=false//鼠标点击截屏

    },
    //初始化第2步状态值
    initSecond() {
     // 搜狗输入法的快捷短语
		this.isShowdy1_1=true,//显示快捷短语的第一张图片
		this.isShowdy1_2=false,//鼠标移入高级
		this.isShowdy1_3=false,//鼠标点击高级
		this.isShowdy1_4=false,//鼠标移入自定义短语
		this.isShowdy1_5=false,//鼠标点击自定义短语
		this.isShowdy1_6=false,//鼠标移入添加新短语
		this.isShowdy1_7=false,//鼠标点击添加新短语
		this.isShowdy1_7_input='',//缩写输入框
		this.isShowdy1_7_textarea='',//内容输入框
		this.isShowdy1_7_select=1,//候选位置值
		this.isShowdy1_7_selectopint=[
			{value:1,
			label:1
			},
			{value:2,
			label:2
			},
			{value:3,
			label:3
			},
			{value:4,
			label:4
			},
			{value:5,
			label:5
			},
			{value:6,
			label:6
			},
			{value:7,
			label:7
			},
			{value:8,
			label:8
			},
			{value:9,
			label:9
			}
		],//候选位置下拉框值
		this.isShowdy1_8=false,//鼠标点击确定并添加
		this.isShowdy1_9=false,//鼠标点确定

		// 显示调用界面
		this.isShowdy1_10=false,//鼠标点击高级
		this.isb=0,//记录b按下次数
		this.isShowdy1_11=false,//键盘连续输入bb
		this.isShowdy1_12=false,//键盘移入2
		this.isShowdy1_13=false,//键盘点击2
		this.isShowdy1_14=false//鼠标点击发送
    },
    
  	//初始化所有tab内容
  	initAll() {
    	//第1步
    	this.initFirst()
     	//第2步
     	this.initSecond()
     	//第3步
    //  	this.initThird()
    //  	//第4步
    //  	this.initFour()
    //  	//第5步
    //  	this.initFive()
    //  	//第6步
    //   this.initSix()
    //   //第7步
    //   this.initSeven()
    //   //第8步
    //   this.initEight()
    //   //第9步
    //   this.initNine()
    //   //第10步
    //   this.initTen()
    //   //第11步
    //   this.initEleven()
    //   //第12步
    //   this.initTwelve()
  	},
    //开始实操练习
    startStudy() {
    	$('#stoptip-'+this.tabCurrent).hide();
    	$('#content-'+this.tabCurrent).show();
    	this.addRecord('START', 1);
    },
    //下一关
    studyNext(next, index, tabCurrent) {
    	$('.el-tabs__header').find('.js-tab').each(function() {
    		$(this).removeClass('is-active');
    	});
    	$(next).addClass('is-active');
    	$('.el-tabs__content').find('.el-tab-pane').each(function() {
    		$(this).hide();
    	});
    	$(next+'-content').show();
    	this.tabCurrent = tabCurrent;
    	this.addRecord('START', index);
    },
    //第1步-单击千牛图标
    // showLoginImg() {
    // 	this.isShowQnIcon = false
    // 	this.isShowQnIcon2 = true
    // },
    // //双击千牛图标
    // showLoginImg2() {
    // 	this.isShowQnIcon2 = false
    // 	this.isShowLoginImg = true
    // },
    // //登录
    // loginIn() {
    //   if(this.name == '') {
    //     this.notify('<p>请输入账号</p>')
    //     return
    //   }else if(this.name != '淘金客服:001') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   if(this.password == '') {
    //     this.notify('<p>请输入密码</p>')
    //     return
    //   }else if(this.password != 'TJ2019') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   this.isShowLoginImg = false
    //   this.isShowRnd = true
    // },
    // //验证码登录
    // loginInRnd() {
    // 	if(this.rnd == '') {
    //     this.notify('<p>请输入短信验证码</p>')
    //     return
    //   }else if(this.rnd != '660220') {
    //     this.notify('<p>短信验证码错误</p>')
    //     return
    //   }
    //   this.isShowRnd = false
    //   this.isShowLoginIndex = true
    // },
	//第1步-鼠标移入输入法
    showLoginqh1_1(){
        this.isShowqh1_1=false
        this.isShowqh1_2=true

    },
    //鼠标点击输入法
    showLoginqh1_2(){
        this.isShowqh1_2=false
        this.isShowqh1_3=true

    },
    //鼠标移入搜狗输入法
    showLoginqh1_3(){
        this.isShowqh1_3=false
        this.isShowqh1_4=true

    },
    //鼠标点击搜狗输入法
    showLoginqh1_4(){
        this.isShowqh1_4=false
        this.isShowqh1_5=true
        // 设置截屏页面显示
        setTimeout(() => {
           this.isShowqh1_5=false
           this.isShowjp1_1=true

        }, 2000);

    },
     //鼠标移入输入法设置
    showLoginjp1_1(){
        this.isShowjp1_1=false
        this.isShowjp1_2=true

    },
     //鼠标点击输入法设置
    showLoginjp1_2(){
        this.isShowjp1_2=false
        this.isShowjp1_3=true

    },
     //鼠标移入截屏设置
    showLoginjp1_3(){
        this.isShowjp1_3=false
        this.isShowjp1_4=true

    },
   
     //点击鼠标右键
    showLoginjp1_4(){
        this.isShowjp1_4=false
        this.isShowjp1_5=true

    },
     //鼠标点击发送到桌面
    showLoginjp1_5(){
        this.isShowjp1_5=false
        this.isShowjp1_6=true
        // 设置截屏快捷键页面显示
        setTimeout(() => {
            this.isShowjp1_6=false
            this.isShowkj1_1=true
        }, 2000);

    },
	//鼠标移入输入法
	showLoginkj1_1(){
		this.isShowkj1_1=false
		this.isShowkj1_2=true
	},
	//鼠标点击输入法菜单
	showLoginkj1_2(){
		this.isShowkj1_2=false
		this.isShowkj1_3=true
	},
	//鼠标点击更多设置
	showLoginkj1_3(){
		this.isShowkj1_3=false
		this.isShowkj1_4=true
	},
	//鼠标移入按键
	showLoginkj1_4(){
		this.isShowkj1_4=false
		this.isShowkj1_5=true
	},
	//鼠标点击按键
	showLoginkj1_5(){
		this.isShowkj1_5=false
		this.isShowkj1_6=true
	},
	// //滚轮滑动
	// gunlun(e){
	// 	console.log(e)
	// 	if(e.deltaY>0){
	// 		this.isShowkj1_6=false
	// 		this.isShowkj1_7=true
	// 	}
	// },
	//鼠标移入系统功能快捷键设置
	showLoginkj1_6(){
			this.isShowkj1_6=false
			this.isShowkj1_8=true	
	},
	//鼠标点击系统功能快捷键设置
	showLoginkj1_7(){
			this.isShowkj1_8=false
			this.isShowkj1_9=true	
	},
	// //滚轮滑动
	// showLoginkj1_8(e){
	// 	if(e.deltaY>0){
	// 		this.isShowkj1_9=false
	// 		this.isShowkj1_10=true
	// 	}
	// },
	//鼠标移入截屏
	showLoginkj1_9(){
			this.isShowkj1_9=false
			this.isShowkj1_11=true
	},
	//鼠标点击截屏单选框
	showLoginkj1_10(){
			this.isShowkj1_11=false
			this.isShowkj1_12=true
			var self = this
			this.addRecord('END',1)
            setTimeout(function() {
                 $('#studytip-'+self.tabCurrent).show();
            }, 2000);
	},
	
    // 搜狗输入法的快捷短语
	// 搜狗输入法的快捷短语的第一张图显示// 鼠标移入高级
   showLogindy1_1(){
	   this.isShowdy1_1=false
	   this.isShowdy1_2=true
   },
	// 鼠标点击高级
   showLogindy1_2(){
	   this.isShowdy1_2=false
	   this.isShowdy1_3=true
   },
	//鼠标移入自定义短语设置
   showLogindy1_3(){
	 
			this.isShowdy1_3=false
			this.isShowdy1_4=true
	
   },
	//鼠标点击自定义短语设置
   showLogindy1_4(){
	  		this.isShowdy1_4=false
			this.isShowdy1_5=true
   },
	//鼠标移入添加新短语
   showLogindy1_5(){
	  		this.isShowdy1_5=false
			this.isShowdy1_6=true
   },
	//鼠标点击添加新短语
   showLogindy1_6(){
	  		this.isShowdy1_6=false
			this.isShowdy1_7=true
   },
	//鼠标点击确定并继续添加
   showLogindy1_7(){
	  		if(this.isShowdy1_7_input!='bb'){
				 this.notify('<p>请将“缩写”按照要求编辑</p>')
				  
			  }else{
				  if(this.isShowdy1_7_textarea!='报备：去上厕所，离开3分钟'){
					  this.notify('<p>请将“内容”按照要求编辑</p>')
				  }else{
					  
					  this.isShowdy1_7=false
					  this.isShowdy1_7_input=''
					  this.isShowdy1_7_textarea=''
					  this.isShowdy1_8=true

				  }
			  }
		
   },
	//鼠标点击确定
   showLogindy1_8(){
	  		if(this.isShowdy1_7_input!='bb'){
				 this.notify('<p>请将“缩写”按照要求编辑</p>')
				  
			  }else{
				  if(this.isShowdy1_7_textarea!='报备：去上厕所，离开5分钟'){
					  this.notify('<p>请将“内容”按照要求编辑</p>')
				  }else{
					  if(this.isShowdy1_7_select!=2){
						   this.notify('<p>请将“候选位置”按照要求编辑</p>')
					  }else{
						this.isShowdy1_8=false
					  	this.isShowdy1_9=true
						//   延时两秒显示调用页面
						setTimeout(() => {
							this.isShowdy1_9=false
							this.isShowdy1_10=true
						}, 2000);
					  }
					

				  }
			  }
		
   },
   //连续点击两次b
   showLogindy1_9(){
	   this.isShowdy1_10=false
	   this.isShowdy1_11=true
   },
   //鼠标移到2
   showLogindy1_10(){
	   this.isShowdy1_11=false
	   this.isShowdy1_12=true
   },
   //键盘按下2
   showLogindy1_10_1(){
	   this.isShowdy1_11=false
	   this.isShowdy1_13=true
   },
   //鼠标点击2
   showLogindy1_11(){
	   this.isShowdy1_12=false
	   this.isShowdy1_13=true
   },
   //鼠标点击发送
   showLogindy1_12(){
	   this.isShowdy1_13=false
	   this.isShowdy1_14=true
	   	var self = this
		this.addRecord('END',2)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
   },
   //按下键盘enter
   showLogindy1_12_1(){
	   this.isShowdy1_13=false
	   this.isShowdy1_14=true
	   	var self = this
		this.addRecord('END',2)
    	setTimeout(function() {
        $('#studytip-'+self.tabCurrent).show();
      }, 2000);
   },


    // //进入接待中心
    // enterJd() {
    // 	var self = this
    // 	this.isShowLoginIndex = false
    // 	this.isShowLoginIndexTwo = true
    // 	this.addRecord('END', 1)
    // 	setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
    // },
    //第2步-切换状态-显示未挂起图片
	 //第2步-
    
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString (date, format) { // 时间格式化
      var date = new Date(date),
        o = {
          "M+" : date.getMonth() + 1,
          "d+" : date.getDate(),
          "h+" : date.getHours(),
          "m+" : date.getMinutes(),
          "s+" : date.getSeconds(),
          "q+" : Math.floor((date.getMonth() + 3) / 3),
          "S" : date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday(n){
      let lastDays = new Date().setDate((new Date().getDate() - n));
      let lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord(type, index) {
      var data = {
        exerciseType: 'SOUGOU_INPUT_EXAM',
        stepSeq: index,
        exerciseAction: type
      }
      this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res=> {
        var result = res.data
        if(result.success) {
           if(index==2 && type=='END'){
		    window.parent['goBack']();
		  }
        }else {
          this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          })
        }
      },res=> {
        this.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        })
      })
    }
  } 
}
</script>
<style lang="less" scoped>
.account-table {
  border-top: 1px solid #000000;
  border-left: 1px solid #000000;
  margin: 10px;
  border-spacing: inherit;
  > tr > td {
    border-right: 1px solid #000000;
    border-bottom: 1px solid #000000;
    padding: 5px;
  }
}
#newQianniuExam .content .qnbox{
	width: 1060px;
    height: 650px;
    position: relative;
}
#newQianniuExam .content .qnbox .qnicon01{
	position: absolute;
    // top: calc(50% - 37px);
    // bottom: calc(50% - 37px);
    margin-top: -218px;
    // left: calc(50% - 38px);
    // right: calc(50% - 38px);
    margin-left: -285px;
    width: 98px;
    height: 98px;
}
// #newQianniu .content .qnbox .qnicon02
#newQianniuExam .content .qnbox  .qnicon02-1{
	width: 67px !important;
    height: 21px !important;
	top:216px;
	left:473px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
#newQianniuExam .content .qnbox  .qnicon04-1{
	width: 176px !important;
    height: 43px !important;
	top:486px;
	left:272px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
#newQianniuExam .content .qnbox  .qnicon05-1{
	width: 123px !important;
    height: 32px !important;
	top:491px;
	left:286px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
#newQianniuExam .content .qnbox  .qnicon06-1{
	width: 120px !important;
    height: 92px !important;
	top:389px;
	left:533px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
#newQianniuExam .content .qnbox  .qnicon09-1{
	width: 59px !important;
    height: 20px !important;
	top:399px;
	left:372px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#newQianniuExam .content .qnbox  .qnicon11-1{
	width: 23px !important;
    height: 12px !important;
	top:519px;
	left:260px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
#newQianniuExam .content .qnbox  .qnicon13-1{
	width: 69px !important;
    height: 15px !important;
	top:461px;
	left:367px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
    
	}
	//测试
#newQianniuExam .content .con-left{
	height: calc(~'100vh' - 217px) !important;
	width: calc(~'100%' - 210px) !important;
	}	
#newQianniuExam .content .con-right{
	height: calc(~'100vh' - 214px);
	width: 200px;
	}
//
// #content-second .qnbox .nr1-1{
// 	position:absolute;
// 	width: 71px !important;
//     height: 17px !important;
// 	top:351px;
// 	left:668px;
// 	cursor: pointer;
// 	// top: calc(50% - 196px) !important;
// 	// left: calc(50% - 86px) !important;
    
// 	}
#content-second .qnbox .nr1-1tb{
	position:absolute;
	width: 71px !important;
    height: 15px !important;
	top:352px;
	left:752px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .nr1_2input{
	position:absolute;
	width: 71px !important;
    height: 15px !important;
	top:352px;
	left:752px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .exclenrbox {
	   width: 1060px;
       height: 650px;

      position: relative;
    
	}

#content-second .qnbox .nr1-3tb{
	position:absolute;
	width: 71px !important;
    height: 15px !important;
	top:329px;
	left:38px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-second .qnbox .nr1_4input{
	position:absolute;
	width: 71px !important;
    height: 16px !important;
	top:370px;
	left:36px;
	cursor: pointer;
	// top: calc(50% - 196px) !important;
	// left: calc(50% - 86px) !important;
}
#content-first .qnbox .qhtb1-1{
	position:absolute;
	width: 18px !important;
    height: 20px !important;
	top:620px;
	left:906px;
	cursor: pointer;

}
#content-first .qnbox .qhtb1-2{
	position:absolute;
	width: 15px !important;
    height: 16px !important;
	top:622px;
	left:908px;
	cursor: pointer;

}
#content-first .qnbox .qhtb1-3{
	position:absolute;
	width: 298px !important;
    height: 62px !important;
	top:424px;
	left:756px;
	cursor: pointer;

}
#content-first .qnbox .qhtb1-4{
	position:absolute;
	width: 296px !important;
    height: 57px !important;
	top:428px;
	left:756px;
	cursor: pointer;

}
#content-first .qnbox .jptb1-1{
	position:absolute;
	width: 14px !important;
    height: 16px !important;
	top:71px;
	left:496px;
	cursor: pointer;

}
#content-first .qnbox .jptb1-2{
	position:absolute;
	width: 19px !important;
    height: 18px !important;
	top:70px;
	left:493px;
	cursor: pointer;

}
#content-first .qnbox .jptb1-3{
	position:absolute;
	width: 249px !important;
    height: 71px !important;
	top:502px;
	left:453px;
	cursor: pointer;

}
#content-first .qnbox .jptb1-4{
	position:absolute;
	width: 84px !important;
    height: 34px !important;
	top:539px;
	left:605px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-1{
	position:absolute;
	width: 34px !important;
    height: 31px !important;
	top:60px;
	left:337px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-2{
	position:absolute;
	width: 34px !important;
    height: 31px !important;
	top:59px;
	left:337px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-3{
	position:absolute;
	width: 249px !important;
    height: 516px !important;
	top:20px;
	left:112px;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-4{
	position:absolute;
	width: 63px !important;
    height: 48px !important;
	top:438px;
	left:284px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-5{
	position:absolute;
	width: 34px !important;
    height: 16px !important;
	top:411px;
	left:143px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-6{
	position:absolute;
	width: 31px !important;
    height: 16px !important;
	top:411px;
	left:143px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-6-1_box{
	position:absolute;
	width: 674px !important;
    height: 456px !important;
	top:142px;
	left:298px;
	overflow:auto;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-6-1_box::-webkit-scrollbar{
	display: none !important;

}
#content-first .qnbox .kjtb1-6-1{
	// position:absolute;
	width: 100% !important;
    height: 746px !important;
	// top:133px;
	// left:302px;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-7{
	position:absolute;
	width: 617px !important;
    height: 466px !important;
	top:133px;
	left:302px;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-8{
	position:absolute;
	width: 562px !important;
    height:37px !important;
	top:452px;
	left:47px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-9{
	position:absolute;
	width: 613px !important;
    height:38px !important;
	top:297px;
	left:305px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-9-1{
	position:absolute;
	width: 674px !important;
    height:472px !important;
	top:127px;
	left:298px;
	overflow: auto;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-9-1::-webkit-scrollbar{
	display: none;
}
#content-first .qnbox .kjtb1-10{
	// position:absolute;
	width: 100% !important;
    height:682px !important;
	// top:131px;
	// left:303px;
	// cursor: pointer;

}
#content-first .qnbox .kjtb1-11{
	position:absolute;
	width: 606px !important;
    height:39px !important;
	top:466px;
	left:13px;
	cursor: pointer;

}
#content-first .qnbox .kjtb1-12{
	position:absolute;
	width: 17px !important;
    height:17px !important;
	top:389px;
	left:324px;
	cursor: pointer;

}
#content-second .qnbox .dytb1-1{
	position:absolute;
	width: 32px !important;
    height:15px !important;
	top:457px;
	left:157px;
	cursor: pointer;

}
#content-second .qnbox .dytb1-2{
	position:absolute;
	width: 31px !important;
    height:18px !important;
	top:457px;
	left:157px;
	cursor: pointer;

}
#content-second .qnbox .qnbg1-3-1box{
	position:absolute;
	width: 677px !important;
    height:472px !important;
	top:129px;
	left:308px;
	overflow:auto;
	

}
#content-second .qnbox .qnbg1-3-1box::-webkit-scrollbar{display: none;}
#content-second .qnbox .dytb1-3{
	// position:absolute;
	width:100% !important;
    height:700px !important;
	// top:170px;
	// left:315px;


}
#content-second .qnbox .dytb1-4{
	position:absolute;
	width: 588px !important;
    height:39px !important;
	top:575px;
	left:31px;
	cursor: pointer;

}
#content-second .qnbox .dytb1-5{
	position:absolute;
	width: 614px !important;
    height:37px !important;
	top:477px;
	left:316px;
	cursor: pointer;

}
#content-second .qnbox .dytb1-6{
	position:absolute;
	width: 88px !important;
    height:21px !important;
	top:81px;
	left:843px;
	cursor: pointer;}
#content-second .qnbox .dytb1-7{
	position:absolute;
	width: 87px !important;
    height:21px !important;
	top:81px;
	left:843px;
	cursor: pointer;

}
#content-second .qnbox .isShowdy1_7_input{
	position:absolute;
	width: 236px !important;
    // height:25px !important;
	top:218px;
	left:313px;
	cursor: pointer;

}
#content-second .qnbox .isShowdy1_7_input /deep/ .el-input__inner{
height: 32px;

}
#content-second .qnbox .isShowdy1_7_textarea{
	position:absolute;
	width: 450px !important;
    // height:25px !important;
	top:303px;
	left:313px;
	cursor: pointer;

}
#content-second .qnbox .isShowdy1_7_textarea /deep/ .el-textarea__inner{
	height: 114px !important;

}
#content-second .qnbox .dytb1-8{
	position:absolute;
	width: 121px !important;
    height:25px !important;
	top:430px;
	left:317px;
	cursor: pointer;

}
#content-second .qnbox .isShowdy1_7_select{
	position:absolute;
	width: 111px !important;
    height:25px !important;
	top:220px;
	left:589px;
	cursor: pointer;

}
#content-second .qnbox .isShowdy1_7_select /deep/ .el-input__inner{
	background:#F5F7FC;
	height: 28px;
	border-color: #F5F7FC;
}
#content-second .qnbox .isShowdy1_7_select /deep/ .el-select .el-input .el-select__caret{
	color: #000;
	font-size:13px;
	font-weight: 500;
}
#content-second .qnbox .isShowdy1_7_select /deep/ .el-input__icon{
line-height: 38px;
}
#content-second .qnbox .dytb1-9{
	position:absolute;
	width: 84px !important;
    height:26px !important;
	top:430px;
	left:582px;
	cursor: pointer;

}
#content-second .qnbox .dytb2-1{
	position:absolute;
	width: 237px !important;
    height:44px !important;
	top:457px;
	left:525px;
	cursor: pointer;

}
#content-second .qnbox .dytb2-2{
	position:absolute;
	width: 84px !important;
    height:24px !important;
	top:528px;
	left:568px;
	cursor: pointer;

}
.mynone {
    display: none !important;
}

</style>


// WEBPACK FOOTER //
// ./src/page/typewriting/typewritingstudy.vue